import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {preferenceToBool} from './use-site-preferences'

const HIDE_LOYALTY_UI_FOR_INTERNATIONAL_CONFIG = 'HIDE_LOYALTY_UI_FOR_INTERNATIONAL'

/**
 * Returns true when loyalty-specific UI should be hidden for the active locale.
 *
 * The flag is read from SSR config so server rendering and the initial client render
 * agree before any client-only preference requests run.
 *
 * @returns {boolean} Whether loyalty UI should be hidden for the current international locale.
 */
export const useHideLoyaltyUIForInternational = () => {
    const {locale} = useMultiSite()
    const {app: appConfig} = getConfig()

    const isInternational = Boolean(locale?.isSupportedByESW)
    const isPreferenceEnabled = preferenceToBool(
        appConfig?.[HIDE_LOYALTY_UI_FOR_INTERNATIONAL_CONFIG]
    )

    return isInternational && isPreferenceEnabled
}

export default useHideLoyaltyUIForInternational
